var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-eb345e06\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./tech-3.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader!./~/vue-markdown-loader/_cache/tech-3.vue
// module id = 169
// module chunks = 0